import { render, staticRenderFns } from "./Irelmi.vue?vue&type=template&id=13bade11&scoped=true"
import script from "./Irelmi.vue?vue&type=script&lang=js"
export * from "./Irelmi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bade11",
  null
  
)

export default component.exports